module.exports = __webpack_public_path__ + "static/media/noun-kitchen-2838070-808080.98da9017.svg";